/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class LiveApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `LiveApiModule.forRoot()`
 */
export interface LiveApiConfigurationParams {
  rootUrl?: string;
}
